import { inject, Injectable } from '@angular/core';
import { WINDOW } from './window.token';
import { getTenant } from './multi-tenant-auth';
import { ENV } from './env.token';

@Injectable({
  providedIn: 'root',
})
export class TenantContextService {
  private readonly window: Window = inject(WINDOW);
  private readonly env = inject(ENV);

  getTenant(): string | null {
    return getTenant(this.window.location.hostname, this.env);
  }
}
